// this file contains shared tracking logic for all routes by deriving common attributes from api data types
// which are used across all routes and defined globally common attributes like source, partner id etc.

import { createTracker } from '@/lib/analytics/create-tracker';
// import type { BaseCabItemOption, RideDetails } from '@/api/types';
// import type { FormattedAddress } from '@ixigo/cab-core/location';

/**
 * all routes should inherit attributes from this tracker.
 * we'll register common cab specific attributes here
 */
export const globalTracker = createTracker({
	trackMap: {},
});

export function getCommonAttributes() {
	const urlSearchParams = new URLSearchParams(window.location.search);
	const source = urlSearchParams.get('source');
	const commonAttributes: Record<string, string> = {};
	if (source) {
		commonAttributes.Source = source;
	}
	return commonAttributes;
}

export function initGlobalAppTracker() {
	const defaultAttributes = getCommonAttributes();
	globalTracker.setContext(() => ({
		getCommonAttributes: () => ({
			...defaultAttributes,
			...getCommonAttributes(),
		}),
	}));
}
